import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogoGMIM } from "../../../assets";
import { Menu, X } from "lucide-react"; // ikon hamburger & close
import "./navbar.scss";

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "Warta Jemaat & Tata Ibadah", path: "/warta-jemaat" },
    { label: "Renungan", path: "/renungan" },
    {
      label: "Struktur Organisasi BPMJ & Pelsus",
      path: "/struktur-organisasi",
    },
    { label: "Tentang Genesaret", path: "/tentang-genesaret" },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false); // tutup menu setelah klik
  };

  return (
    <div className="navbar-wrap">
      {/* Logo */}
      <div className="logo-wrap" onClick={() => handleNavigate("/")}>
        <img src={LogoGMIM} alt="Logo GMIM" className="logo" />
        <div className="text-wrap">
          <p className="title">Gereja Masehi Injili di Minahasa</p>
          <p className="subtitle">Jemaat Genesaret Pateten</p>
        </div>
      </div>

      {/* Tombol Hamburger */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <X size={26} /> : <Menu size={26} />}
      </div>

      {/* Menu Navigasi */}
      <div className={`menu-wrap ${menuOpen ? "open" : ""}`}>
        {menuItems.map((item) => {
          let isActive = false;
          const currentPath = location.pathname;

          if (item.path === "/") {
            // Home hanya aktif jika path persis sama dengan '/'
            isActive = currentPath === "/";
          } else {
            // Menu lain aktif jika currentPath dimulai dengan path menu tersebut
            isActive = currentPath.startsWith(item.path);
          } // ------------------------------------
          return (
            <span
              key={item.label}
              className={`menu-item ${isActive ? "active" : ""}`}
              onClick={() => handleNavigate(item.path)}
            >
              {item.label}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default NavBar;